module.exports = __webpack_public_path__ + "img/bomo_logo.50e05085.jpg";